// Import Font loader
import WebFont from 'webfontloader';

// Import Alert
import Alert from '../modules/alert';

// Menu
import Menu from '../modules/menu';
import MenuScroll from '../modules/menu-scroll';

// Carousel
import Carousel from '../modules/carousel';

// Ingredient Measurement
import selectedMeasurement from '../modules/selected-measurement';

// Sharelinks
import Sharelinks from 'sharelinks';

// Recipes Module
import Recipes from '../modules/recipes';

// Create Box
import createBox from '../modules/create-box';

// Bundled Product
import Bundle from '../modules/bundle';

// Single Item Bundle
import singleItemBundle from '../modules/single-item-bundle';

// Import Logo Carousel
import LogoCarousel from '../modules/logo-carousel';

// Ajax Form
import ajaxForm from '../ajax-form';

import ShareCount from '../modules/share-count';

export default {
  init () {
    // JavaScript to be fired on all pages
    if (
      document.body.contains(document.querySelector('.module-contact form'))
    ) {
      $('.js-contact-form').ajaxForm({
        responseDiv: '.js-contact-form-result'
      });
    }

    // Newsletter
    $('.tofino-mc-form').ajaxForm({
      hideFormAfterSucess: true,
      responseDiv: '.js-newsletter-form-result'
    });

    Carousel();

    selectedMeasurement();

    // Sharelinks
    new Sharelinks('.share', {
      platforms: ['email']
      // Define a callback for when a link is clicked
      // callback: (e) => {
      //   console.log('Link Shared!');
      //   console.info('Platform', e.platform);
      //   console.info('Url', e.url);
      // }
    });

    // Load Fonts
    WebFont.load({
      custom: {
        families: ['Aquino']
      },
      google: {
        families: ['Open+Sans:wght@300;400;700;900'],
        display: 'swap',
        version: 2
      }
    });

    // Alert
    if (
      document.body.contains(document.getElementById('tofino-notification'))
    ) {
      Alert();
    }

    // Menu
    if (document.body.contains(document.getElementById('header-nav'))) {
      Menu();
      MenuScroll();
    }

    // Recipe Posts Module
    if (document.body.contains(document.getElementById('recipes'))) {
      Recipes();
    }

    // Bundle Module
    if (document.body.contains(document.getElementById('bundle'))) {
      Bundle();
    }

    // Create Box
    if (
      document.body.contains(
        document.querySelector('.single-product .product-type-bundle')
      )
    ) {
      createBox();
    }

    if (
      document.body.contains(
        document.querySelector('.is-part-of-bundle .single_add_to_cart_button')
      )
    ) {
      singleItemBundle();
    }

    // Logo Carousel
    if (document.body.contains(document.querySelector('.js-logo-carousel'))) {
      LogoCarousel();
    }

    // On checkout page, re-calculate totals on postcode/state/country change
    if (document.body.contains(document.querySelector('.woocommerce-checkout'))) {
      const shippingFields = document.querySelectorAll('#shipping_postcode_field, #shipping_state_field, #shipping_country_field');

      if (shippingFields.length) {
        shippingFields.forEach((el) => {
          el.classList.add('update_totals_on_change');
        });
      }
    }

    // Hide shipping fields if Local Pickup
    $('form.checkout').on(
      'change',
      'input[name^="shipping_method"]',
      function () {
        let val = $(this).val();

        const shippingColumn = document.querySelector(
          '#customer_details .col-2'
        );

        // console.log(val);
        // console.log(shippingColumn);

        if (val.match('^local_pickup')) {
          shippingColumn.classList.add('hidden');

          const inputFields = shippingColumn.getElementsByTagName(
            'input, textarea, select'
          );

          for (let i = 0; i < inputFields.length; i++) {
            inputFields[i].value = '';
          }
        } else {
          shippingColumn.classList.remove('hidden');
        }
      }
    );
  },
  finalize () {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
  loaded () {
    // Javascript to be fired on page once fully loaded

    // Share Count
    if (document.querySelector('.js-share-count')) {
      ShareCount();
    }
  }
};
